<template>
  <block style="padding-bottom: 60px;">
    <template slot="header"
      >Cambio de matrícula</template
    >

    <div class="alert-type">
      <h4 class="is-uppercase">Nuevo Estado de Matrícula</h4>

      <div class="control">
        <select v-model="selectedStateId" required>
          <option value="-1" selected disabled>Seleccionar estado</option>
          <option v-for="s in availableStudentStates" :key="s.id" :value="s.id">{{
            s.code
          }}</option>
        </select>
      </div>
    </div>

    <div class="alert-details">
      <h4 class="is-uppercase">CAUSA</h4>
      <textarea
        v-model="details"
        placeholder="Por favor especificar la causa del cambio"
      ></textarea>
    </div>

    <derivation-list :derivations.sync="derivations"></derivation-list>

    <div class="actions">
      <button
        class="button is-primary add"
        :class="{ 'is-loading': loading }"
        :disabled="!isValid"
        @click="submit"
      >
        Agregar
      </button>
      <button class="button is-primary is-outlined cancel" :disabled="loading" @click="cancel">
        Cancelar
      </button>
    </div>
  </block>
</template>

<script>
import gql from "graphql-tag"

import PROFILE_DETAIL from "../home/graphql/Profile.gql"
import STUDENT_COMMENTS from "../comments/graphql/StudentComments.gql"

import Block from "@/components/_base/Block.vue"
import DerivationList from "@/components/_base/DerivationList.vue"
import OverlayedMixin from "@/mixins/OverlayedMixin"

export default {
  name: "ProfileChangeSituacion",
  mixins: [OverlayedMixin],
  props: {
    studentId: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      studentStates: [],
      studentProfile: {
        student: {
          responsible: {},
          currentState: {}
        }
      },
      selectedStateId: -1,
      details: "",
      users: [],
      derivations: []
    }
  },
  apollo: {
    studentStates: gql`
      query StudentStates {
        studentStates {
          id
          code
          persistence
        }
      }
    `,
    users: gql`
      query Users {
        users {
          id
          name
          email
        }
      }
    `,
    studentProfile: {
      query: gql`
        query StudentProfile($studentId: ID!) {
          studentProfile(studentId: $studentId) {
            student {
              responsible {
                name
              }
              currentState {
                id
              }
            }
          }
        }
      `,
      variables() {
        return {
          studentId: this.studentId
        }
      }
    }
  },
  computed: {
    isValid() {
      if (this.selectedStateId == -1 || this.selectedStateId == null) {
        return false
      }
      if (this.details.length == 0) {
        return false
      }
      return true
    },
    validDerivations() {
      const derivations = this.derivations.map(d => {
        return {
          userId: d.chosenUser && d.chosenUser.id ? d.chosenUser.id : null,
          message: d.message || null
        }
      })
      // Filter the ones without a user
      const validDerivations = derivations.filter(d => d.userId != null)
      return validDerivations
    },
    responsibleName() {
      const responsible = this.studentProfile.student.responsible || {}
      return responsible.name || "-"
    },

    availableStudentStates() {
      const currentState = this.studentProfile.student.currentState || {}

      if (currentState) {
        // If the student has a current state, filter it out so the user
        // change the state to the same one again
        return this.studentStates.filter(s => {
          return currentState.id !== s.id
        })
      } else {
        return this.studentStates
      }
    }
  },
  methods: {
    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    },
    submit() {
      const input = {
        studentId: this.studentId,
        studentStateId: this.selectedStateId,
        comment: this.details,
        derivations: this.validDerivations
      }

      this.loading = true
      this.$apollo
        .mutate({
          mutation: gql`
            mutation ChangeStudentState($input: ChangeStudentStateInput!) {
              changeStudentState(input: $input) {
                id
                currentState {
                  id
                  code
                }
              }
            }
          `,
          variables: {
            input: input
          },
          refetchQueries: [
            { query: PROFILE_DETAIL, variables: { studentId: this.studentId } },
            { query: STUDENT_COMMENTS, variables: { studentId: this.studentId, n: 100 } }
          ]
        })
        .then(data => {
          this.loading = false
          this.navigateTo("app.profile.home")
        })
        .catch(error => {
          this.loading = false
        })
    },
    cancel() {
      this.navigateTo("app.profile.home")
    }
  },
  components: {
    Block,
    DerivationList
  }
}
</script>

<style scoped>
.alert-type,
.alert-details,
.alert-responsible,
.alert-derivation {
  margin-bottom: 35px;
}

h4 {
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}

select {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  height: 35px;
  width: 350px;
  background-color: #f2f2f2;
  color: #7a7a7a;
}

textarea {
  box-sizing: border-box;
  resize: vertical !important;
  display: block;
  width: 100%;
  min-height: 66px;
  background-color: #f2f2f2;
  border-color: #e0e0e0;
  border-radius: 5px;
  padding: 10px 10px;
}

.responsible-message {
  display: block;
  box-sizing: border-box;
  width: 100%;
  background-color: #f2f2f2;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  padding-left: 10px;
  height: 35px;
}
</style>
